const CART_PRODUCTS_DOMAIN = 'cartProducts'

const CART_PRODUCTS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const CART_PRODUCTS_PATH = {
  DATA: `${CART_PRODUCTS_DOMAIN}.data`
}

const CART_PRODUCTS_ENDPOINT = {
  UPDATE: '/cart/updateCartProduct',
  DELETE: '/cart/deleteCartProduct'
}

export {
  CART_PRODUCTS_STATE,
  CART_PRODUCTS_DOMAIN,
  CART_PRODUCTS_ENDPOINT,
  CART_PRODUCTS_PATH
}
